export const ASSETS = {
  portrait: "https://customer-assets-m6fa6gv7.emergentagent.net/job_purnia-civil-lawyer/artifacts/f9bi67kx_77B90E9F-F0CA-4731-844A-C85D729ED020.jpg",
  logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_purnia-civil-lawyer/artifacts/spsyvhow_%20-2.jpg",
  consistency: "https://customer-assets-m6fa6gv7.emergentagent.net/job_purnia-civil-lawyer/artifacts/o49c9yis_%20-3.jpg",
  success: "https://customer-assets-m6fa6gv7.emergentagent.net/job_purnia-civil-lawyer/artifacts/beuxdh5s_%20-4.jpg",
};

export const CONTACT = {
  name: "Adv. Sanjay Kr Sinha",
  credentials: "BA Hons., MA, LLB",
  role: "Civil & Revenue Litigation Lawyer",
  location: "Purnia, Bihar",
  phone: "9973866110",
  phoneDisplay: "+91 99738 66110",
  whatsapp: "919973866110",
  experience: "26+",
  court: "District & Civil Court, Purnia",
};

export const NAV_LINKS = [
  { label: "Counsel", href: "#about" },
  { label: "Practice", href: "#services" },
  { label: "Jurisdiction", href: "#jurisdiction" },
  { label: "Resources", href: "#resources" },
  { label: "Consult", href: "#consult" },
];

export const SERVICES = [
  {
    no: "01",
    title: "Property & Land Dispute",
    desc: "Resolution of title, boundary, encroachment and ownership disputes over immovable property and agricultural land.",
  },
  {
    no: "02",
    title: "Partition & Succession",
    desc: "Division of ancestral and joint family property, inheritance claims and succession certificate matters.",
  },
  {
    no: "03",
    title: "Contractual Dispute",
    desc: "Enforcement, breach and interpretation of agreements, deeds and commercial contracts before civil courts.",
  },
  {
    no: "04",
    title: "Money Recovery",
    desc: "Recovery of debts, dues and outstanding payments through civil suits and summary procedures.",
  },
  {
    no: "05",
    title: "Injunction Matter",
    desc: "Temporary and permanent injunctions to protect possession, rights and prevent irreparable harm.",
  },
  {
    no: "06",
    title: "Specific Performance",
    desc: "Compelling performance of contracts, particularly sale agreements of immovable property.",
  },
  {
    no: "07",
    title: "Possession & Eviction",
    desc: "Landlord–tenant disputes, wrongful dispossession and lawful eviction proceedings.",
  },
  {
    no: "08",
    title: "Probate & Estate Matter",
    desc: "Wills, probate, letters of administration and the orderly settlement of estates.",
  },
];

export const RESOURCES = [
  {
    tag: "Civil Procedure",
    title: "Understanding limitation periods in property suits",
    read: "5 min read",
  },
  {
    tag: "Revenue Law",
    title: "Mutation records and their evidentiary value in Bihar",
    read: "6 min read",
  },
  {
    tag: "Guidance",
    title: "What to bring to your first consultation",
    read: "3 min read",
  },
];
